module.exports = __webpack_public_path__ + "media/images/flags/32/Falkland-Islands-fc05b85bdffaa9aea8e7685b2c57b46b.png";